import prefetchHelper from "./prefetch"
import emitter from "./emitter"
import { setMatchPaths, findPath, findMatchPath } from "./find-path"

/**
 * Available resource loading statuses
 */
export const PageResourceStatus = {
  /**
   * At least one of critical resources failed to load
   */
  Error: `error`,
  /**
   * Resources loaded successfully
   */
  Success: `success`,
}

const preferDefault = m => (m && m.default) || m

const stripSurroundingSlashes = s => {
  s = s[0] === `/` ? s.slice(1) : s
  s = s.endsWith(`/`) ? s.slice(0, -1) : s
  return s
}

const createPageDataUrl = rawPath => {
  const [path, maybeSearch] = rawPath.split(`?`)
  const fixedPath = path === `/` ? `index` : stripSurroundingSlashes(path)
  return `${__PATH_PREFIX__}/page-data/${fixedPath}/page-data.json?v=0291e04ae088eafae30715e445b3e775?v=5a0603762361031097ea896475717802?v=8a80d3e3881efba056a9fdb8434c0e02?v=1958020398a6fbb488656459ba2b1260?v=a76b21dd9ca5c2433682ce5aeac97e5e?v=f78e58fd518d08cb7aa7aed16d2aafa8?v=371665b05a82adef6bc74c0a7b33a9ba?v=09b3e876ad0db54dddf4ead1f257c3f7?v=d1c548e00a371c9656dbcd370dd199d9?v=9052a4062009564de129ae574a281824?v=65466425257734ac6eca59b404a2bd70?v=2f0f753c038e2011ab1477eb43b02257?v=36cb4900104ed8c1a420385e7bc553fe?v=d3d9272754055d26987b24f8d61e5636?v=7d13519251677d83b187c755df3df316?v=dec83fe94462d0a39c9275a8ceb0052c?v=3838ae948f2299fa490832e90b519375?v=1153e49fee5b531f53f9bcff0e634b76?v=04797f75a84150d0039bba7e1bb27529?v=bb2c468257d20380664fe2723f06688f?v=64203051b248dccb69bb977f53c75855?v=aa6b155cea50e368339a56eb18ef51d5?v=0b39a36e68f7e472d3dfe12e56d187da?v=44a5639d07ff75d2aa9cd93ec0d2f513?v=004741680d8e08e3270ae8ee0d941b85?v=0b04bb6bdc5a7aa67b284a497874f9be?v=a299f681c3780bae3d2b00c88f1dbe02?v=f133963efcdec31556ded2da0aae70f9?v=2834d80638c76a32c3f489ffec3e5fb2?v=4d06639942181fac1cd71e51ae17502f?v=7431514b35f60a854824f6af713a28e5?v=1cec6c7ffa47ff79e1c21876232cad20?v=c3b221d23cf4bbaac9d04dda6abb8711?v=1234ffd5ba5856c84ce8de93798d5abb?v=aa29ea7d80cb17ad80e7e990b87697b5?v=b11f83e56b867152fd0428f0bea16676?v=9e54a4358fd94f85c29d10ad31911bac?v=0aec2924fff62f7826b9be6e75787219?v=e06bdbfd90a096188a182c6cd0e91b6b?v=5033e5de74e34d827c178bd00e94a1c9?v=7833cecefe196a1d6a0e0f0ad0455f50?v=5e9cf52fa2d3344333c716def1b9816d?v=afc7f0580701e9de3cd532b13a5c3afb?v=439ecd4ed25f9e5631cf2cd819c1c018?v=4ce1c3c9b01c01c37bad5de6d24e85cb?v=e0dbb92ccaffbded9a15b47ee226e835?v=02ad19f1e3d016f5e598a08af2c60386?v=4b1d9ceb8df75870af10a09030a5273f?v=a081b0162bb786c99dda19397a9ef5b8?v=d44f7f44f166c5c15d991fde76769c66?v=b09d159c223b47c3e58c9752e5867b01?v=9472d37cb28e44fc260b36f3945f2ff6?v=3e0b0bb4d065a13c8fb18dc4b57a3f69?v=631b16156f0fd4e882d3a6e06717acfa?v=26d09e7049ff5a6f89865558a22666dc?v=7076ea7e5097b291c012a37dee88ed04?v=220a8a805f68afe3a853bf6f7ef47a07?v=8efae087b4e93058df54bfcbd0a1434e?v=79a28e86bdecf6e3cbbcef08754b37c6?v=a02ea3054294bb6a9be228c5bfee2f3f?v=05ea8bbaec9353189de8536ce7e5db65?v=4031a946f4878a356d7f9c1376cd75ed?v=1732301092ad2549401faba17bcdf9ee?v=cd40dbde0c2d791bb3b65b2a7d6e18ce?v=0212274e4e392647dcf8ea427a6d3ef1?v=c492c6089ad22041fcb68731b0be323f?v=5270519484df8543daabeff9a03ffc8e?v=5c22828983dc0b657e9143f057ba31d2?v=c7a1e67124238576f755118501964188?v=c7a120e0f3e0468bbcedc9ee1645f179?v=61989648d3c3bb1b1357864df494724c?v=4cc29eb67e8dea0e4f092de9bd61ebef?v=0dbd9f7e8fb2e1a6b2780717e20c7516?v=eadbcd7bd4e89a5bd0c93e5c1f0c9d45?v=ca8548d25afbed69c21b214dc9df88dc?v=8d42de608fac20ce75641fb4f3c6d6d7?v=1c3ce84608b95735dc68f3d7dcaf3e06?v=d7a6ac2e8edd58aa756a167b0997f582?v=8fa30b15ca4e02757f48c05faae33448?v=b6477a2b2ee5f8ba40b9ca48bda33337?v=0c7a37c1575164426237909e209d230e?v=ea086353236061ebe287243f2b55cc40?v=a1466ca3c4a2737b7b5875d2f896264d?v=2b26053268d764df4c6def33fe96a06c?v=88a095ac39078da95952451dc99c1e36?v=845181227a2f8fd24937d0a9359bda00?v=2af46c54b9f34e9e772aa6f426ac6834?v=7bee06b65ced086dc5815670937a6803?v=e531520062a12f922c7a57c34497d109?v=922e5ea4e48082ccd1ab55ab0b67e0ce?v=7d4f7e76b50d3b27a77b0b5129197eaa?v=049867869a39b7897d511a7b7962fdca?v=48d0032dbdaa0beea072efb9bd067b64?v=b81119e75e0f1626195ad9b90bbc06ea?v=df3955394788e8dfa44704026482d404?v=7f320a96e84cd118179fb3975fa305e2?v=9b734befa7245a83ae00e9b807eb7cd1?v=03853baf78e0bcb44ecb5617374930d0?v=45a82775621875d9c8f4b1c06c413164?v=18ac11a7c811bae5d979b44d8ec0805e?v=2fb3b435624553497f9d04cfc716783d?v=142d87d964decbe08b39124dc040e52a?v=c2853c6619788a60c44520d9c68055b9?v=27aadeca8eafa5453eaa31cc9846bf90?v=4e0efc56d7cdd3bcb1c2e46e7f2a0749?v=0c5a387a206934ee52caebfb1d3aa810?v=2193d1c88a0a790232bde834c5f6b21c?v=5dac3995c0a5f46ea0870f1a1ac2f1a7?v=de44d5a7145b9cd2a336609f60b7bafa?v=ee94cdaadc33c9dc5f8ecb333cd34213?v=e81529f3758d9ea8ae65285f67683abd?v=8728426818c226a99b7147a2d57a3285?v=c58e5eadc86ae87469ad340e20b11450?v=d63c72bd6088f2d3767c9e23d9e47e67?v=b047426b6666fd8cd3a32754a162415e?v=9a30331f6f1a407862eeeabf301df982?v=c6ce0c3850cad7450e7e8cfd7d80a6dd?v=75b0d4982ea5f41b0c49b429ec8f5e2a?v=82230b7743c8bf3fd3339c9129acec69?v=eb46db0fccd313bb7b50bd811ad73695?v=2b39fbaabe365b2d0dc82be24f026176?v=67cdeb572dd863f8676b091e56b69d3d?v=65132388537b37d13670d0543e5d4fa1?v=d84d123421d0d1293583e05bf8ff86fe?v=747aac4d93c00ad6be5eabfadfd9644b?v=2511a18dc923e5aa5d1e2844bae6d516?v=3f0499bb3eab77302bcc6f357e372c78?v=0bbcde8c308aa4ad34f601e1696dfde1?v=225b7c8cfd8674d32f94c1622fe0cf27?v=96d25a16b131a0160b8d120592681600?v=85eec3fefa3bea530b38e8f84c2493ba?v=f085d8aa64b460e7ad40e7afd4d27429?v=477088b661e08f8673b8ca2f6e95ecd1?v=22926e3443e06d84994a81fd5d1ff7e7?v=895209dd44af75ccaa9bd4cc11f6a0a9?v=333d1ad5bf2c7436521e3849bec6cc3f?v=8e31f8412305b853aea6a299486fd6e3?v=3f3c995f33be930cf739ea5a16d454d4?v=6c63468b30a758bbd557d7c73d128c7b?v=bf16410c4cf760a00b546901e28c0830?v=43455d9f07a37dc653e62b1c712bb4c4?v=66a2b71e3022dc51eaa6182ac3a0da2f?v=b8af2f8ff35607f57ddb88c03c3008ff?v=cdea10058295ecb3cfa1658ba790daed?v=6017e9825dfdd2b244ab03063212e98d?v=556ec5a2892f6e61f099e968c67b27d5?v=d9d67a931d0a8581aab44abebe52a592?v=c619abc31e253af290d090ca33005b71?v=23ab116dbbd59783bcf8ce54bad5009a?v=7272fe9aa4b08091d7b3d9dd33de86b6?v=380d7733d6aae0c723d2a36785a2b220?v=0a4462ffe5b960e326fb3adfdd15e38a?v=5919424dd9f7a37278bacdf6c344ff95?v=454d93f5da1667f4f36cecf8c7efcf74?v=e2409e581cac2f5e50c9a3d609d747f7?v=3c8d06db0a6580e36bf4fd74cf3aa72b?v=1fcdc7e8107de5906ca499ad26e92b7b?v=a5fac74807aafc606e13419b0e8da9de?v=c66d2245ef071bf1c8bb9263707a2ef5?v=162e56c5af65343328e25ff88e16aa8c?v=6236ef648a7b76748b13691923cff737?v=06b040939b417d8daf00798d73191543?v=4267ec957bda17cccc8941797d3f51be?v=4df3dd16573560f0b68fdf77f496c1c9?v=010e78184bbbc8ef5af56a33ed2fe02b?v=a21b3ac87b89043dad7c29fff2ee2adf?v=ca131dc1af062bd0462b000ab32efe0b?v=8e943f133b1de3a65c2a281506f0d142?v=07cb77c659619f2ee6991f03474fcd26?v=d00ccd43eeceb827373d1204d9fca981?v=3c459031e8526e0b0f079a112dbdef99?v=a3c5b7a69956e2f894a68b3af67a09e7?v=0f5265acc439bf1993b377d89cf0bc05?v=e92bb7ed7c8a77ddc20e352397407d42?v=c37d03a73c39c7246011ad93fbca2486?v=3219521de43d36b591936065da205b4e?v=f3cf7fef286576820283ff878943cf53?v=39919786b77f015a5e868710fee4c206?v=4a7ab66fcc00dc83e0e54f859df135c1?v=95b395c424defbf3b3f060dda371569b?v=bbb9eb8dee9f45d0396d8bcc4c1b2043?v=198400b0a6c3daaa0ecec7c7290ca085?v=2131cec61c9189309a4f354120f284b8?v=09bcde331b973a00a8ef6aa4d1c5fac9?v=ef672bfbb5cb4a7246455700d5360316?v=5e12d576407cef125fefcdab5c323857?v=92c673ce624a9c6ce9e11a9268db7397?v=378b5bb78c41b9c57f0ee44bb8073540?v=337d051ad7f4d78aebfa9dbc4a2d85e8?v=cf3b085b099a3508a5e733038badf750?v=ad53c66c9ec0b9c851931f32241ca283?v=c16313e4af26fb9c2c4b35a349dd9f20?v=ca1478258f09c90bc9c3210ca785524b?v=c76ed62389168cdce655d0467114d1e5?v=7dfeabe4f9f11c21b39c7f5636cf0672?v=a443d9690fc0c75385694efb78a5f47b?v=9f56f57dd89b5ca2064159b15adb0735?v=59b388049f62adb17021bc19895fea3b?v=6ee11c9ba2fac305f58d75df3775e767?v=bc819b251f8aac8a76c6a46bacc163dc?v=5e82a5392e2495ff0a55a9d65f73edb5?v=fb12505f62dceab36db99c63473e3f68?v=0a918635c244f1e9a5dcf0eed7e35c98?v=005ed33c9f7d03b115a3df1decf03fd3?v=289e42333851344e8c049034a30a4f64?v=bd79e47c49da59e1396a640f9cfa6872?v=eb364b5aed43127fb6a22c1577669510?v=58175744da6b1aa21d28b2f253cee192?v=9eefa88c41b4cbe844b256830860fb2e?v=8d7183e109fb7c661b0f9af54bc43dea?v=4003f42a24e05c3e1c07ab2bf77fec1e?v=f02566a88dd557791f973885ace46ea2?v=e1d921f1042e8736ee404d97955d2c30?v=f241670d18905899f118c005175d1be7?v=adb9493b014efe1c94409e2ddb898dd9?v=196e91dab418f0a9229e6464c18cd8f1?v=5f371ef94785860e50479c37aef02c5e?v=a7a939397dc511e62206015fdb156a38?v=a3db87c27c074aedc0946efbc1c9efc0?v=a7fc5f6e3b52c05164e6e6461f1c0198?v=b83367aa157266bbb879f4655978e28e?v=ad34329699dc11ff0f8a679dd4b9f044?v=282ef5e6cf85afc969176369b9e22ed3?v=36d0c10910e702cbe0e6a5f6f37cb4dc?v=af1a795e155352f70b81581cc9ea5b68?v=049f6458c28396b187bd9f14d17d3066?v=702c770054532e2974c2b8280ae930a3?v=88690e2a43a26f1b722b786101bd5bca?v=fcfc2db54f971f8ad39037b030848d68?v=6ce971db3762af1d60a7f36064c434fd?v=d963eeef13a86d5dac29e75ca55f07e3?v=4d8e93f9145edf0e363da0742f9e54f5?v=9d4f0ed23b7447a091ee4fa08bf24e9f?v=9d32f61b7cf4e4384dedf6ab34758598?v=9e0d8889280ffc31f81326a9adf90e5d?v=dd66ea5e9626cd885080f6e912631431?v=ae061ac3f614ff5403ef1aa243560d22?v=d2300e53723576a566b167252cec0884?v=1f699926bd8d0f0f3ee48314e45d7b48?v=9b19aff2830c698d682f7197b77e5bcf?v=9cd9cbe9f608a669da1f7c04ac36b103?v=ade259c3e5479047f77ad8ad838f56df?v=91e16963bce003774b4072d9a55d6519?v=e819242541a4237b8cbc8522bf3a05db?v=c88ff46b89e5527d51be1dcdace8f741?v=80a35a0fd7d76d0f83b69a5b012aeaad?v=b2896e84e50272d096b4731e4eb46953?v=ecf9954120fea678f2f0b952aee9ad64?v=d8347a4d0a848c979f77e446a199950c?v=738ac8f4fd55a30d3071e9543755688a?v=c0962a9e1e8dfbf20ea15aebcd0b5866?v=420daf89069364eca1a9559a60beff40?v=08aad5a99d1e508d2e195c8937d2d8e2?v=a8b69271e914dbf8dc318418c489a8f7?v=a8d8c16046adf8bcbba5634f4429c151?v=690d6623e0551c2aca1ad5fd7093d57a?v=6ac59309b868505d7fca43a5e300ce2d?v=325be58423ac1959c6e33b7f200da5c1?v=ea53b881d9ac8050d5233278017db353?v=245f090340c1638d77cdef858cbe625f?v=1167f12e47d1b7e32b2b19770cd995dd?v=864716a0df63994af3774feb1d95a833?v=c6bcda7cc488399d888628923108beee?v=7166e3561d3058991690da280e5c5b60?v=91e820a4fb7859e31cd2701806c595a0?v=9efe17c45bd230a10d66fae1aa535389?v=1e4c7bd286d718735bc1c160ee07ca57?v=c5282e3cc49794b7404b482b6afbad9e?v=8eb94904c4b7eee6a3e6d60f9081c17b?v=adad7ca037268f42e5ec88d62d6650fc?v=70b5718d62cd1cb8f060a5906c171654?v=888879a4e93d73be34f16141a3ebc0fb?v=14af0f445bdf560c6cff6347b0a408e5?v=c07ccbbbfd05ea4b2775a66b66065319?v=ac4eb698a8f9274ccec040b29e646b83?v=eb44b666f24c9fee2d4c48cf16d85ce6?v=17fc3288027f8ac5557931f47a033cba?v=c117a4f2ab070e6a85087477cbc01618?v=d294ed331f4bc26dd90ff93f085b1d71?v=4f30e2b2012d6c017261356913524aa8?v=d8d948e56cc9ff75cbe4007dee71e592?v=a1c41aa6b15e8a42eddf43aa73d649d3?v=30f192f41b650e5545c08241bdbb0954?v=9110ea26b5121651cc037f5ecc671bad?v=eebb7ce509a60f3682c2cf66d62a1e5a?v=ef7e0b89bc42eaf91ec2dd91cb25128a?v=09176ed9fbc86fa3092dc55d4e8b41e3?v=ea38e5ea63b14b51bdfc30e71da6da6c?v=47c405ca3b6ada79e1a7f303a6e39b1a?v=a1f17f41c7d48ee00669ed82019f53d2?v=59a9e8fd55adf77c7103b5f5f68c8b8e?v=2a7e2c37df760b8800783b780f346468?v=24c23cc0721507555f0f984999d1c785?v=47eb54625553bc54e31b8263ad8ac824?v=29063684db475935ca5d6e688058c881?v=20825fcec439a52bfadcb67ddb47e410?v=a9aca7b892926f29015355d24950f603?v=64c14722f0ebe260557f72c82343a89d?v=57ca611b8faa0fbdf024c3dc6df6cf28?v=05d943c6aea40a97aa2b2e4ab57feb42${
    maybeSearch ? `?${maybeSearch}` : ``
  }`
}

/**
 * Utility to check the path that goes into doFetch for e.g. potential malicious intentions.
 * It checks for "//" because with this you could do a fetch request to a different domain.
 */
const shouldAbortFetch = rawPath => rawPath.startsWith(`//`)

function doFetch(url, method = `GET`) {
  return new Promise(resolve => {
    const req = new XMLHttpRequest()
    req.open(method, url, true)
    req.onreadystatechange = () => {
      if (req.readyState == 4) {
        resolve(req)
      }
    }
    req.send(null)
  })
}

const doesConnectionSupportPrefetch = () => {
  if (
    `connection` in navigator &&
    typeof navigator.connection !== `undefined`
  ) {
    if ((navigator.connection.effectiveType || ``).includes(`2g`)) {
      return false
    }
    if (navigator.connection.saveData) {
      return false
    }
  }
  return true
}

// Regex that matches common search crawlers
const BOT_REGEX = /bot|crawler|spider|crawling/i

const toPageResources = (pageData, component = null, head) => {
  const page = {
    componentChunkName: pageData.componentChunkName,
    path: pageData.path,
    webpackCompilationHash: pageData.webpackCompilationHash,
    matchPath: pageData.matchPath,
    staticQueryHashes: pageData.staticQueryHashes,
    getServerDataError: pageData.getServerDataError,
    slicesMap: pageData.slicesMap ?? {},
  }

  return {
    component,
    head,
    json: pageData.result,
    page,
  }
}

function waitForResponse(response) {
  return new Promise(resolve => {
    try {
      const result = response.readRoot()
      resolve(result)
    } catch (err) {
      if (
        Object.hasOwnProperty.call(err, `_response`) &&
        Object.hasOwnProperty.call(err, `_status`)
      ) {
        setTimeout(() => {
          waitForResponse(response).then(resolve)
        }, 200)
      } else {
        throw err
      }
    }
  })
}

export class BaseLoader {
  constructor(loadComponent, matchPaths) {
    // Map of pagePath -> Page. Where Page is an object with: {
    //   status: PageResourceStatus.Success || PageResourceStatus.Error,
    //   payload: PageResources, // undefined if PageResourceStatus.Error
    // }
    // PageResources is {
    //   component,
    //   json: pageData.result,
    //   page: {
    //     componentChunkName,
    //     path,
    //     webpackCompilationHash,
    //     staticQueryHashes
    //   },
    //   staticQueryResults
    // }
    this.pageDb = new Map()
    this.inFlightDb = new Map()
    this.staticQueryDb = {}
    this.pageDataDb = new Map()
    this.partialHydrationDb = new Map()
    this.slicesDataDb = new Map()
    this.sliceInflightDb = new Map()
    this.slicesDb = new Map()
    this.isPrefetchQueueRunning = false
    this.prefetchQueued = []
    this.prefetchTriggered = new Set()
    this.prefetchCompleted = new Set()
    this.loadComponent = loadComponent
    setMatchPaths(matchPaths)
  }

  inFlightNetworkRequests = new Map()

  memoizedGet(url) {
    let inFlightPromise = this.inFlightNetworkRequests.get(url)

    if (!inFlightPromise) {
      inFlightPromise = doFetch(url, `GET`)
      this.inFlightNetworkRequests.set(url, inFlightPromise)
    }

    // Prefer duplication with then + catch over .finally to prevent problems in ie11 + firefox
    return inFlightPromise
      .then(response => {
        this.inFlightNetworkRequests.delete(url)
        return response
      })
      .catch(err => {
        this.inFlightNetworkRequests.delete(url)
        throw err
      })
  }

  setApiRunner(apiRunner) {
    this.apiRunner = apiRunner
    this.prefetchDisabled = apiRunner(`disableCorePrefetching`).some(a => a)
  }

  fetchPageDataJson(loadObj) {
    const { pagePath, retries = 0 } = loadObj
    const url = createPageDataUrl(pagePath)
    return this.memoizedGet(url).then(req => {
      const { status, responseText } = req

      // Handle 200
      if (status === 200) {
        try {
          const jsonPayload = JSON.parse(responseText)
          if (jsonPayload.path === undefined) {
            throw new Error(`not a valid pageData response`)
          }

          const maybeSearch = pagePath.split(`?`)[1]
          if (maybeSearch && !jsonPayload.path.includes(maybeSearch)) {
            jsonPayload.path += `?${maybeSearch}`
          }

          return Object.assign(loadObj, {
            status: PageResourceStatus.Success,
            payload: jsonPayload,
          })
        } catch (err) {
          // continue regardless of error
        }
      }

      // Handle 404
      if (status === 404 || status === 200) {
        // If the request was for a 404/500 page and it doesn't exist, we're done
        if (pagePath === `/404.html` || pagePath === `/500.html`) {
          return Object.assign(loadObj, {
            status: PageResourceStatus.Error,
          })
        }

        // Need some code here to cache the 404 request. In case
        // multiple loadPageDataJsons result in 404s
        return this.fetchPageDataJson(
          Object.assign(loadObj, { pagePath: `/404.html`, notFound: true })
        )
      }

      // handle 500 response (Unrecoverable)
      if (status === 500) {
        return this.fetchPageDataJson(
          Object.assign(loadObj, {
            pagePath: `/500.html`,
            internalServerError: true,
          })
        )
      }

      // Handle everything else, including status === 0, and 503s. Should retry
      if (retries < 3) {
        return this.fetchPageDataJson(
          Object.assign(loadObj, { retries: retries + 1 })
        )
      }

      // Retried 3 times already, result is an error.
      return Object.assign(loadObj, {
        status: PageResourceStatus.Error,
      })
    })
  }

  fetchPartialHydrationJson(loadObj) {
    const { pagePath, retries = 0 } = loadObj
    const url = createPageDataUrl(pagePath).replace(`.json`, `-rsc.json`)
    return this.memoizedGet(url).then(req => {
      const { status, responseText } = req

      // Handle 200
      if (status === 200) {
        try {
          return Object.assign(loadObj, {
            status: PageResourceStatus.Success,
            payload: responseText,
          })
        } catch (err) {
          // continue regardless of error
        }
      }

      // Handle 404
      if (status === 404 || status === 200) {
        // If the request was for a 404/500 page and it doesn't exist, we're done
        if (pagePath === `/404.html` || pagePath === `/500.html`) {
          return Object.assign(loadObj, {
            status: PageResourceStatus.Error,
          })
        }

        // Need some code here to cache the 404 request. In case
        // multiple loadPageDataJsons result in 404s
        return this.fetchPartialHydrationJson(
          Object.assign(loadObj, { pagePath: `/404.html`, notFound: true })
        )
      }

      // handle 500 response (Unrecoverable)
      if (status === 500) {
        return this.fetchPartialHydrationJson(
          Object.assign(loadObj, {
            pagePath: `/500.html`,
            internalServerError: true,
          })
        )
      }

      // Handle everything else, including status === 0, and 503s. Should retry
      if (retries < 3) {
        return this.fetchPartialHydrationJson(
          Object.assign(loadObj, { retries: retries + 1 })
        )
      }

      // Retried 3 times already, result is an error.
      return Object.assign(loadObj, {
        status: PageResourceStatus.Error,
      })
    })
  }

  loadPageDataJson(rawPath) {
    const pagePath = findPath(rawPath)
    if (this.pageDataDb.has(pagePath)) {
      const pageData = this.pageDataDb.get(pagePath)
      if (process.env.BUILD_STAGE !== `develop` || !pageData.stale) {
        return Promise.resolve(pageData)
      }
    }

    return this.fetchPageDataJson({ pagePath }).then(pageData => {
      this.pageDataDb.set(pagePath, pageData)

      return pageData
    })
  }

  loadPartialHydrationJson(rawPath) {
    const pagePath = findPath(rawPath)
    if (this.partialHydrationDb.has(pagePath)) {
      const pageData = this.partialHydrationDb.get(pagePath)
      if (process.env.BUILD_STAGE !== `develop` || !pageData.stale) {
        return Promise.resolve(pageData)
      }
    }

    return this.fetchPartialHydrationJson({ pagePath }).then(pageData => {
      this.partialHydrationDb.set(pagePath, pageData)

      return pageData
    })
  }

  loadSliceDataJson(sliceName) {
    if (this.slicesDataDb.has(sliceName)) {
      const jsonPayload = this.slicesDataDb.get(sliceName)
      return Promise.resolve({ sliceName, jsonPayload })
    }

    const url = `${__PATH_PREFIX__}/slice-data/${sliceName}.json`
    return doFetch(url, `GET`).then(res => {
      const jsonPayload = JSON.parse(res.responseText)

      this.slicesDataDb.set(sliceName, jsonPayload)
      return { sliceName, jsonPayload }
    })
  }

  findMatchPath(rawPath) {
    return findMatchPath(rawPath)
  }

  // TODO check all uses of this and whether they use undefined for page resources not exist
  loadPage(rawPath) {
    const pagePath = findPath(rawPath)
    if (this.pageDb.has(pagePath)) {
      const page = this.pageDb.get(pagePath)
      if (process.env.BUILD_STAGE !== `develop` || !page.payload.stale) {
        if (page.error) {
          return Promise.resolve({
            error: page.error,
            status: page.status,
          })
        }

        return Promise.resolve(page.payload)
      }
    }

    if (this.inFlightDb.has(pagePath)) {
      return this.inFlightDb.get(pagePath)
    }

    const loadDataPromises = [
      this.loadAppData(),
      this.loadPageDataJson(pagePath),
    ]

    if (global.hasPartialHydration) {
      loadDataPromises.push(this.loadPartialHydrationJson(pagePath))
    }

    const inFlightPromise = Promise.all(loadDataPromises).then(allData => {
      const [appDataResponse, pageDataResponse, rscDataResponse] = allData

      if (
        pageDataResponse.status === PageResourceStatus.Error ||
        rscDataResponse?.status === PageResourceStatus.Error
      ) {
        return {
          status: PageResourceStatus.Error,
        }
      }

      let pageData = pageDataResponse.payload

      const {
        componentChunkName,
        staticQueryHashes: pageStaticQueryHashes = [],
        slicesMap = {},
      } = pageData

      const finalResult = {}

      const dedupedSliceNames = Array.from(new Set(Object.values(slicesMap)))

      const loadSlice = slice => {
        if (this.slicesDb.has(slice.name)) {
          return this.slicesDb.get(slice.name)
        } else if (this.sliceInflightDb.has(slice.name)) {
          return this.sliceInflightDb.get(slice.name)
        }

        const inFlight = this.loadComponent(slice.componentChunkName).then(
          component => {
            return {
              component: preferDefault(component),
              sliceContext: slice.result.sliceContext,
              data: slice.result.data,
            }
          }
        )

        this.sliceInflightDb.set(slice.name, inFlight)
        inFlight.then(results => {
          this.slicesDb.set(slice.name, results)
          this.sliceInflightDb.delete(slice.name)
        })

        return inFlight
      }

      return Promise.all(
        dedupedSliceNames.map(sliceName => this.loadSliceDataJson(sliceName))
      ).then(slicesData => {
        const slices = []
        const dedupedStaticQueryHashes = [...pageStaticQueryHashes]

        for (const { jsonPayload, sliceName } of Object.values(slicesData)) {
          slices.push({ name: sliceName, ...jsonPayload })
          for (const staticQueryHash of jsonPayload.staticQueryHashes) {
            if (!dedupedStaticQueryHashes.includes(staticQueryHash)) {
              dedupedStaticQueryHashes.push(staticQueryHash)
            }
          }
        }

        const loadChunkPromises = [
          Promise.all(slices.map(loadSlice)),
          this.loadComponent(componentChunkName, `head`),
        ]

        if (!global.hasPartialHydration) {
          loadChunkPromises.push(this.loadComponent(componentChunkName))
        }

        // In develop we have separate chunks for template and Head components
        // to enable HMR (fast refresh requires single exports).
        // In production we have shared chunk with both exports. Double loadComponent here
        // will be deduped by webpack runtime resulting in single request and single module
        // being loaded for both `component` and `head`.
        // get list of components to get
        const componentChunkPromises = Promise.all(loadChunkPromises).then(
          components => {
            const [sliceComponents, headComponent, pageComponent] = components

            finalResult.createdAt = new Date()

            for (const sliceComponent of sliceComponents) {
              if (!sliceComponent || sliceComponent instanceof Error) {
                finalResult.status = PageResourceStatus.Error
                finalResult.error = sliceComponent
              }
            }

            if (
              !global.hasPartialHydration &&
              (!pageComponent || pageComponent instanceof Error)
            ) {
              finalResult.status = PageResourceStatus.Error
              finalResult.error = pageComponent
            }

            let pageResources

            if (finalResult.status !== PageResourceStatus.Error) {
              finalResult.status = PageResourceStatus.Success
              if (
                pageDataResponse.notFound === true ||
                rscDataResponse?.notFound === true
              ) {
                finalResult.notFound = true
              }
              pageData = Object.assign(pageData, {
                webpackCompilationHash: appDataResponse
                  ? appDataResponse.webpackCompilationHash
                  : ``,
              })

              if (typeof rscDataResponse?.payload === `string`) {
                pageResources = toPageResources(pageData, null, headComponent)

                pageResources.partialHydration = rscDataResponse.payload

                const readableStream = new ReadableStream({
                  start(controller) {
                    const te = new TextEncoder()
                    controller.enqueue(te.encode(rscDataResponse.payload))
                  },
                  pull(controller) {
                    // close on next read when queue is empty
                    controller.close()
                  },
                  cancel() {},
                })

                // Only load this experimental module if opting in to experimental Partial Hydration
                return import(`react-server-dom-webpack`)
                  .then(({ createFromReadableStream }) =>
                    waitForResponse(createFromReadableStream(readableStream))
                  )
                  .then(result => {
                    pageResources.partialHydration = result

                    return pageResources
                  })
              } else {
                pageResources = toPageResources(
                  pageData,
                  pageComponent,
                  headComponent
                )
              }
            }

            // undefined if final result is an error
            return pageResources
          }
        )

        // get list of static queries to get
        const staticQueryBatchPromise = Promise.all(
          dedupedStaticQueryHashes.map(staticQueryHash => {
            // Check for cache in case this static query result has already been loaded
            if (this.staticQueryDb[staticQueryHash]) {
              const jsonPayload = this.staticQueryDb[staticQueryHash]
              return { staticQueryHash, jsonPayload }
            }

            return this.memoizedGet(
              `${__PATH_PREFIX__}/page-data/sq/d/${staticQueryHash}.json`
            )
              .then(req => {
                const jsonPayload = JSON.parse(req.responseText)
                return { staticQueryHash, jsonPayload }
              })
              .catch(() => {
                throw new Error(
                  `We couldn't load "${__PATH_PREFIX__}/page-data/sq/d/${staticQueryHash}.json"`
                )
              })
          })
        ).then(staticQueryResults => {
          const staticQueryResultsMap = {}

          staticQueryResults.forEach(({ staticQueryHash, jsonPayload }) => {
            staticQueryResultsMap[staticQueryHash] = jsonPayload
            this.staticQueryDb[staticQueryHash] = jsonPayload
          })

          return staticQueryResultsMap
        })

        return (
          Promise.all([componentChunkPromises, staticQueryBatchPromise])
            .then(([pageResources, staticQueryResults]) => {
              let payload
              if (pageResources) {
                payload = { ...pageResources, staticQueryResults }
                finalResult.payload = payload
                emitter.emit(`onPostLoadPageResources`, {
                  page: payload,
                  pageResources: payload,
                })
              }

              this.pageDb.set(pagePath, finalResult)

              if (finalResult.error) {
                return {
                  error: finalResult.error,
                  status: finalResult.status,
                }
              }

              return payload
            })
            // when static-query fail to load we throw a better error
            .catch(err => {
              return {
                error: err,
                status: PageResourceStatus.Error,
              }
            })
        )
      })
    })

    inFlightPromise
      .then(() => {
        this.inFlightDb.delete(pagePath)
      })
      .catch(error => {
        this.inFlightDb.delete(pagePath)
        throw error
      })

    this.inFlightDb.set(pagePath, inFlightPromise)

    return inFlightPromise
  }

  // returns undefined if the page does not exists in cache
  loadPageSync(rawPath, options = {}) {
    const pagePath = findPath(rawPath)
    if (this.pageDb.has(pagePath)) {
      const pageData = this.pageDb.get(pagePath)

      if (pageData.payload) {
        return pageData.payload
      }

      if (options?.withErrorDetails) {
        return {
          error: pageData.error,
          status: pageData.status,
        }
      }
    }
    return undefined
  }

  shouldPrefetch(pagePath) {
    // Skip prefetching if we know user is on slow or constrained connection
    if (!doesConnectionSupportPrefetch()) {
      return false
    }

    // Don't prefetch if this is a crawler bot
    if (navigator.userAgent && BOT_REGEX.test(navigator.userAgent)) {
      return false
    }

    // Check if the page exists.
    if (this.pageDb.has(pagePath)) {
      return false
    }

    return true
  }

  prefetch(pagePath) {
    if (!this.shouldPrefetch(pagePath)) {
      return {
        then: resolve => resolve(false),
        abort: () => {},
      }
    }
    if (this.prefetchTriggered.has(pagePath)) {
      return {
        then: resolve => resolve(true),
        abort: () => {},
      }
    }

    const defer = {
      resolve: null,
      reject: null,
      promise: null,
    }
    defer.promise = new Promise((resolve, reject) => {
      defer.resolve = resolve
      defer.reject = reject
    })
    this.prefetchQueued.push([pagePath, defer])
    const abortC = new AbortController()
    abortC.signal.addEventListener(`abort`, () => {
      const index = this.prefetchQueued.findIndex(([p]) => p === pagePath)
      // remove from the queue
      if (index !== -1) {
        this.prefetchQueued.splice(index, 1)
      }
    })

    if (!this.isPrefetchQueueRunning) {
      this.isPrefetchQueueRunning = true
      setTimeout(() => {
        this._processNextPrefetchBatch()
      }, 3000)
    }

    return {
      then: (resolve, reject) => defer.promise.then(resolve, reject),
      abort: abortC.abort.bind(abortC),
    }
  }

  _processNextPrefetchBatch() {
    const idleCallback = window.requestIdleCallback || (cb => setTimeout(cb, 0))

    idleCallback(() => {
      const toPrefetch = this.prefetchQueued.splice(0, 4)
      const prefetches = Promise.all(
        toPrefetch.map(([pagePath, dPromise]) => {
          // Tell plugins with custom prefetching logic that they should start
          // prefetching this path.
          if (!this.prefetchTriggered.has(pagePath)) {
            this.apiRunner(`onPrefetchPathname`, { pathname: pagePath })
            this.prefetchTriggered.add(pagePath)
          }

          // If a plugin has disabled core prefetching, stop now.
          if (this.prefetchDisabled) {
            return dPromise.resolve(false)
          }

          return this.doPrefetch(findPath(pagePath)).then(() => {
            if (!this.prefetchCompleted.has(pagePath)) {
              this.apiRunner(`onPostPrefetchPathname`, { pathname: pagePath })
              this.prefetchCompleted.add(pagePath)
            }

            dPromise.resolve(true)
          })
        })
      )

      if (this.prefetchQueued.length) {
        prefetches.then(() => {
          setTimeout(() => {
            this._processNextPrefetchBatch()
          }, 3000)
        })
      } else {
        this.isPrefetchQueueRunning = false
      }
    })
  }

  doPrefetch(pagePath) {
    const pageDataUrl = createPageDataUrl(pagePath)

    if (global.hasPartialHydration) {
      return Promise.all([
        prefetchHelper(pageDataUrl, {
          crossOrigin: `anonymous`,
          as: `fetch`,
        }).then(() =>
          // This was just prefetched, so will return a response from
          // the cache instead of making another request to the server
          this.loadPageDataJson(pagePath)
        ),
        prefetchHelper(pageDataUrl.replace(`.json`, `-rsc.json`), {
          crossOrigin: `anonymous`,
          as: `fetch`,
        }).then(() =>
          // This was just prefetched, so will return a response from
          // the cache instead of making another request to the server
          this.loadPartialHydrationJson(pagePath)
        ),
      ])
    } else {
      return prefetchHelper(pageDataUrl, {
        crossOrigin: `anonymous`,
        as: `fetch`,
      }).then(() =>
        // This was just prefetched, so will return a response from
        // the cache instead of making another request to the server
        this.loadPageDataJson(pagePath)
      )
    }
  }

  hovering(rawPath) {
    this.loadPage(rawPath)
  }

  getResourceURLsForPathname(rawPath) {
    const pagePath = findPath(rawPath)
    const page = this.pageDataDb.get(pagePath)
    if (page) {
      const pageResources = toPageResources(page.payload)

      return [
        ...createComponentUrls(pageResources.page.componentChunkName),
        createPageDataUrl(pagePath),
      ]
    } else {
      return null
    }
  }

  isPageNotFound(rawPath) {
    const pagePath = findPath(rawPath)
    const page = this.pageDb.get(pagePath)
    return !page || page.notFound
  }

  loadAppData(retries = 0) {
    return this.memoizedGet(`${__PATH_PREFIX__}/page-data/app-data.json`).then(
      req => {
        const { status, responseText } = req

        let appData

        if (status !== 200 && retries < 3) {
          // Retry 3 times incase of non-200 responses
          return this.loadAppData(retries + 1)
        }

        // Handle 200
        if (status === 200) {
          try {
            const jsonPayload = JSON.parse(responseText)
            if (jsonPayload.webpackCompilationHash === undefined) {
              throw new Error(`not a valid app-data response`)
            }

            appData = jsonPayload
          } catch (err) {
            // continue regardless of error
          }
        }

        return appData
      }
    )
  }
}

const createComponentUrls = componentChunkName =>
  (window.___chunkMapping[componentChunkName] || []).map(
    chunk => __PATH_PREFIX__ + chunk
  )

export class ProdLoader extends BaseLoader {
  constructor(asyncRequires, matchPaths, pageData) {
    const loadComponent = (chunkName, exportType = `components`) => {
      if (!global.hasPartialHydration) {
        exportType = `components`
      }

      if (!asyncRequires[exportType][chunkName]) {
        throw new Error(
          `We couldn't find the correct component chunk with the name "${chunkName}"`
        )
      }

      return (
        asyncRequires[exportType][chunkName]()
          // loader will handle the case when component is error
          .catch(err => err)
      )
    }

    super(loadComponent, matchPaths)

    if (pageData) {
      this.pageDataDb.set(findPath(pageData.path), {
        pagePath: pageData.path,
        payload: pageData,
        status: `success`,
      })
    }
  }

  doPrefetch(pagePath) {
    return super.doPrefetch(pagePath).then(result => {
      if (result.status !== PageResourceStatus.Success) {
        return Promise.resolve()
      }
      const pageData = result.payload
      const chunkName = pageData.componentChunkName
      const componentUrls = createComponentUrls(chunkName)
      return Promise.all(componentUrls.map(prefetchHelper)).then(() => pageData)
    })
  }

  loadPageDataJson(rawPath) {
    return super.loadPageDataJson(rawPath).then(data => {
      if (data.notFound) {
        if (shouldAbortFetch(rawPath)) {
          return data
        }
        // check if html file exist using HEAD request:
        // if it does we should navigate to it instead of showing 404
        return doFetch(rawPath, `HEAD`).then(req => {
          if (req.status === 200) {
            // page (.html file) actually exist (or we asked for 404 )
            // returning page resources status as errored to trigger
            // regular browser navigation to given page
            return {
              status: PageResourceStatus.Error,
            }
          }

          // if HEAD request wasn't 200, return notFound result
          // and show 404 page
          return data
        })
      }
      return data
    })
  }

  loadPartialHydrationJson(rawPath) {
    return super.loadPartialHydrationJson(rawPath).then(data => {
      if (data.notFound) {
        if (shouldAbortFetch(rawPath)) {
          return data
        }
        // check if html file exist using HEAD request:
        // if it does we should navigate to it instead of showing 404
        return doFetch(rawPath, `HEAD`).then(req => {
          if (req.status === 200) {
            // page (.html file) actually exist (or we asked for 404 )
            // returning page resources status as errored to trigger
            // regular browser navigation to given page
            return {
              status: PageResourceStatus.Error,
            }
          }

          // if HEAD request wasn't 200, return notFound result
          // and show 404 page
          return data
        })
      }
      return data
    })
  }
}

let instance

export const setLoader = _loader => {
  instance = _loader
}

export const publicLoader = {
  enqueue: rawPath => instance.prefetch(rawPath),

  // Real methods
  getResourceURLsForPathname: rawPath =>
    instance.getResourceURLsForPathname(rawPath),
  loadPage: rawPath => instance.loadPage(rawPath),
  // TODO add deprecation to v4 so people use withErrorDetails and then we can remove in v5 and change default behaviour
  loadPageSync: (rawPath, options = {}) =>
    instance.loadPageSync(rawPath, options),
  prefetch: rawPath => instance.prefetch(rawPath),
  isPageNotFound: rawPath => instance.isPageNotFound(rawPath),
  hovering: rawPath => instance.hovering(rawPath),
  loadAppData: () => instance.loadAppData(),
}

export default publicLoader

export function getStaticQueryResults() {
  if (instance) {
    return instance.staticQueryDb
  } else {
    return {}
  }
}

export function getSliceResults() {
  if (instance) {
    return instance.slicesDb
  } else {
    return {}
  }
}
